import PropTypes from "prop-types";
import { useState, useCallback, useEffect } from "react";
import { useFormContext, Controller } from "react-hook-form";
import { DatePicker, Popover, TextField, Icon } from "@shopify/polaris";
import { CalendarIcon } from "@shopify/polaris-icons";

RHFDatePicker.propTypes = {
  name: PropTypes.string.isRequired,
  minDate: PropTypes.instanceOf(Date),
  shouldDisableDate: PropTypes.func,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  disabled: PropTypes.bool,
};

export default function RHFDatePicker({ name, minDate, shouldDisableDate, label, disabled }) {
  const { control, watch } = useFormContext();
  const [popoverActive, setPopoverActive] = useState(false);
  const today = new Date();

  // Get initial value from form
  const selectedDateValue = watch(name);

  // Init month, year based on selectedDate
  const initialDate = selectedDateValue ? new Date(selectedDateValue) : today;
  const [calendarMonth, setCalendarMonth] = useState(initialDate.getMonth());
  const [calendarYear, setCalendarYear] = useState(initialDate.getFullYear());

  useEffect(() => {
    if (selectedDateValue) {
      const newDate = new Date(selectedDateValue);
      setCalendarMonth(newDate.getMonth());
      setCalendarYear(newDate.getFullYear());
    }
  }, [selectedDateValue]);

  const togglePopover = useCallback(() => setPopoverActive((active) => !active), []);

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { value, onChange }, fieldState: { error } }) => {
        const selectedDate = value ? new Date(value) : null;

        return (
          <Popover
            active={popoverActive}
            activator={
              <TextField
                label={label}
                value={selectedDate ? selectedDate.toLocaleDateString() : ""}
                onFocus={togglePopover}
                onChange={() => {}}
                error={error?.message}
                disabled={disabled}
                autoComplete="off"
                suffix={<Icon source={CalendarIcon} color="base" />}
              />
            }
            onClose={togglePopover}
          >
            <Popover.Section>
              <DatePicker
                month={calendarMonth}
                year={calendarYear}
                selected={selectedDate ?? today} // Если value = null, подсвечиваем текущий день
                onChange={(date) => {
                  onChange(date.start);
                  setPopoverActive(false);
                }}
                onMonthChange={(month, year) => {
                  setCalendarMonth(month);
                  setCalendarYear(year);
                }}
                disableDatesBefore={minDate}
                disableDates={shouldDisableDate}
              />
            </Popover.Section>
          </Popover>
        );
      }}
    />
  );
}
